import DataService from "../../../services/client/classes/dataService";
import {IFilterForOrgs} from "../../../private/javascripts/models/interfaces/memberProfile/iFilterForOrgs";

class CommonService extends DataService {
    constructor() {
        super('/database/');
    }

    getStates(city:string = ''):JQuery.jqXHR<any> {
        return this.get(`states/${city}`);
    }

    getCities(search:string):JQuery.jqXHR<any> {
        return this.get('cities/' + search);
    }

    //getStatesAndCities(query?:object):JQuery.jqXHR<any> {
    //    return this.get('cities_old/', query);
    //}

    getDegrees():JQuery.jqXHR<any> {
        return this.get('degrees');
    }

    //getOrgs(orgType:string):JQuery.jqXHR<any> {
    //    return this.get('api_orgs/' + orgType);
    //}

    //getMagors():JQuery.jqXHR<any> {
    //    return this.get('api_magors');
    //}

    getCauses():JQuery.jqXHR<any> {
        return this.get('causes');
    }

    getListOfOrgs(data: IFilterForOrgs): JQuery.jqXHR<any> {
        return this.post('getListOfOrgs', data);
    }

    getOrgByEmail(email: string): JQuery.jqXHR<any> {
        return this.get('getOrgByEmail', {email: email});
    }   

    sendContactUsData(data: any): JQuery.jqXHR<any> {
        return this.post('sendContactUsData/', data);
    }
    //updateOrganizationImage(data: any): JQuery.jqXHR<any> {
    //    return this.post('updateOrganizationImage/', data);
    //}
}

export default new CommonService();


// WEBPACK FOOTER //
// ./static-content/public/javascripts/services/common-service.ts